"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.Breadcrumbs = void 0;
var react_1 = __importStar(require("react"));
var useRovingTabIndex_1 = require("../../hooks/useRovingTabIndex");
var styles_1 = require("../../styles");
var Icon_1 = require("../Icon");
function Breadcrumbs(props) {
    var children = props.children;
    var rootRef = useRovingTabIndex_1.useRovingTabIndex({
        getItems: function (root) { return Array.from(root.querySelectorAll('a')); },
    });
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("nav", { ref: rootRef, "aria-label": 'Breadcrumbs' },
        react_1.default.createElement("ol", { className: classes.list }, react_1.default.Children.map(children, function (child, idx) {
            var isLastItem = idx === react_1.default.Children.count(children) - 1;
            return (react_1.default.createElement(react_1.Fragment, { key: idx },
                react_1.default.createElement("li", { className: css(classes.item, isLastItem && classes.lastItem) }, child),
                !isLastItem && (react_1.default.createElement("li", { role: 'separator', "aria-hidden": true, className: classes.item },
                    react_1.default.createElement(Icon_1.Icon, { size: 1, icon: 'angleRight', style: classes.separator })))));
        }))));
}
exports.Breadcrumbs = Breadcrumbs;
exports.createStyles = function (theme) { return ({
    list: {
        display: 'flex',
        alignItems: 'center',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        textDecoration: 'none',
    },
    item: {
        display: 'inline-flex',
        alignItems: 'center',
        color: theme.pallete.primary.main,
    },
    separator: {
        color: theme.pallete.text.disabled,
        margin: '0 .5rem',
        fontSize: '1rem',
    },
    lastItem: {
        color: theme.pallete.text.main,
        pointerEvents: 'none',
    },
}); };
//# sourceMappingURL=Breadcrumbs.js.map